import * as React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";
import moment from "moment-timezone";

import { breakpoint } from "src/library/utils/styled-media-queries";
import { Text } from "src/library/components/Text";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { OrderOrigin } from "src/core/orders/api/orders.api";
import { PageProps } from "src/pages/Router/routes";
import LoadingSpinner from "src/library/components/LoadingSpinner/LoadingSpinner";
import { useOrder } from "src/core/orders/hooks";
import { CreateOrderContext } from "src/core/shared/components/HeaderContext/CreateOrderContext";
import useDrop from "src/core/drops/hooks/useDrop";

const CreateOrderPage: React.ReactFCWithChildren<PageProps<unknown, {orderDeliveryDate: string; branchId: string;}>> = props => {
  const { match } = props;
  const [ { isCreatingOrder }, { createOrder } ] = useOrder();
  const [ { drop, isLoading } ] = useDrop(match?.params.branchId ? parseInt(match.params.branchId, 10) : undefined);

  React.useEffect(() => {
    if (match?.params.orderDeliveryDate && drop?.id.toString() === match?.params.branchId) {
      createOrder({
        date: moment.utc(match?.params.orderDeliveryDate, "YYYY-MM-DD").toDate(),
        origin: OrderOrigin.Reminder
      });
    }
  }, [
    createOrder,
    drop?.id,
    match?.params.branchId,
    match?.params.orderDeliveryDate
  ]);

  const loading = isLoading || isCreatingOrder;

  return (
    <Layout {...props}>
      <MainContentWrapper fill>

        <OrderInfoContainer>
          <Text fontSize="h1">
            {loading ? "Placing order..." : "Place an order"}
          </Text>

          <ContentContainer>
            {loading ? (
              <LoadingSpinner
                type="circular-pulse"
                position="inline"
              />
            ) : (
              <CreateOrderContext
                direction="left"
                drop={drop}
                loading={isCreatingOrder}
                createDraftOrder={(deliveryDate, options) => createOrder({
                  date: deliveryDate,
                  origin: OrderOrigin.Reminder,
                  orderVariantId: options?.orderVariant?.id
                })}
              />
            )}
          </ContentContainer>
        </OrderInfoContainer>

      </MainContentWrapper>
    </Layout>
  );
};

const OrderInfoContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding: ${theme.spacing.padding.lg};
    background: white;

    h1 {
      font-size: ${theme.fonts.sizes.h1};
    }
    ${breakpoint("md", theme)} {
      width: 50%;
    }
  `}
`;

const ContentContainer = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.padding.md} 0;

    button {
      margin: ${theme.spacing.margins.md} 0;
    }
  `}
`;

export default CreateOrderPage;
